exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".log-message-preview[data-v-8cba6c06]{cursor:pointer}.log-detail-block[data-v-8cba6c06]{background:#f8f9fa;border:1px solid #dee2e6;border-radius:4px;padding:12px;white-space:pre-wrap;word-break:break-word;font-size:.85rem;max-height:300px;overflow:auto}.log-stacktrace[data-v-8cba6c06]{max-height:400px}", ""]);

// exports
